import types from '../mutation-types';
import ConversationFieldDefinitionsAPI from '../../api/conversationFieldDefinitions';

export const state = {
  records: [],
  uiFlags: { isFetching: false, isSaving: false },
};

export const getters = {
  getConversationFieldDefinitions: s => s.records,
  getAll: s => s.records,
  getEnabledConversationFields: s =>
    s.records.filter(f => f.enabled).sort((a, b) => a.position - b.position),
  getConversationFieldUIFlags: s => s.uiFlags,
  uiFlags: s => s.uiFlags,
};

export const actions = {
  async fetchAll({ commit }) {
    commit(types.SET_CONVERSATION_FIELD_DEFINITIONS, { isFetching: true });
    try {
      const { data } = await ConversationFieldDefinitionsAPI.getAll();
      commit(types.SET_CONVERSATION_FIELD_DEFINITIONS, { records: data });
    } finally {
      commit(types.SET_CONVERSATION_FIELD_DEFINITIONS, { isFetching: false });
    }
  },

  async create({ commit }, field) {
    commit(types.SET_CONVERSATION_FIELD_DEFINITIONS, { isSaving: true });
    try {
      await ConversationFieldDefinitionsAPI.create(field);
      const { data } = await ConversationFieldDefinitionsAPI.getAll();
      commit(types.SET_CONVERSATION_FIELD_DEFINITIONS, { records: data });
    } finally {
      commit(types.SET_CONVERSATION_FIELD_DEFINITIONS, { isSaving: false });
    }
  },

  async update({ commit }, { id, ...field }) {
    commit(types.SET_CONVERSATION_FIELD_DEFINITIONS, { isSaving: true });
    try {
      await ConversationFieldDefinitionsAPI.update(id, field);
      const { data } = await ConversationFieldDefinitionsAPI.getAll();
      commit(types.SET_CONVERSATION_FIELD_DEFINITIONS, { records: data });
    } finally {
      commit(types.SET_CONVERSATION_FIELD_DEFINITIONS, { isSaving: false });
    }
  },

  async delete({ commit }, id) {
    await ConversationFieldDefinitionsAPI.delete(id);
    commit(types.DELETE_CONVERSATION_FIELD_DEFINITION, id);
  },

  async reorder({ commit }, ids) {
    await ConversationFieldDefinitionsAPI.reorder(ids);
    const { data } = await ConversationFieldDefinitionsAPI.getAll();
    commit(types.SET_CONVERSATION_FIELD_DEFINITIONS, { records: data });
  },
};

export const mutations = {
  [types.SET_CONVERSATION_FIELD_DEFINITIONS](state, payload) {
    if ('records' in payload) state.records = payload.records;
    if ('isFetching' in payload) state.uiFlags.isFetching = payload.isFetching;
    if ('isSaving' in payload) state.uiFlags.isSaving = payload.isSaving;
  },
  [types.DELETE_CONVERSATION_FIELD_DEFINITION](state, id) {
    state.records = state.records.filter(f => f.id !== id);
  },
  SET_RECORDS(state, records) {
    state.records = records;
  },
};

export default { namespaced: true, state, getters, actions, mutations };
